import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';

type ComboboxItem = {
  id: string;
  value: string;
};

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-combobox',
  templateUrl:
    'console/app-js/shared/components/combobox/combobox.component.html'
})
export class ComboboxComponent implements OnInit, OnChanges {
  @ViewChild('combo', { static: true }) public combo: ComboBoxComponent;
  @Input() listItems: Array<ComboboxItem>;
  @Input() listHeader: string;
  @Input() selection: ComboboxItem;
  @Input() placeholder: string;
  @Input() isDisabled: boolean;
  @Output() valueChange = new EventEmitter();
  @Output() selectionChange = new EventEmitter();
  @Output() filterChange = new EventEmitter();

  source: Array<ComboboxItem>;
  filterText: string;

  constructor(private sanitizer: DomSanitizer) {
    this.sanitizer = sanitizer;
  }

  ngOnInit() {
    this.source = this.listItems.slice();
  }

  /**
   * Implementation from OnChanges interface
   * On every change of the current selection of values.
   */
  public ngOnChanges(): void {
    this.source = this.listItems.slice();
  }

  allowHtml(value: string): SafeHtml {
    const valueRegExp = new RegExp(`(${this.filterText})`, 'i');
    value = value.replace(valueRegExp, '<b>$1</b>');
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

  onUpdateValue(value: ComboboxItem) {
    if (!value) {
      return;
    }
    this.selection = value;
    if (this.valueChange) {
      this.valueChange.emit(this.selection);
    }
  }

  onUpdateSelection(selection: ComboboxItem) {
    if (!selection) {
      return;
    }
    this.selection = selection;
    if (this.selectionChange) {
      this.selectionChange.emit(this.selection);
    }
  }

  onUpdateFilter(filter: string) {
    if (filter) {
      this.filterText = filter;
      this.listItems = this.source.filter((item: ComboboxItem) => {
        return item.value.toLowerCase().indexOf(filter.toLowerCase()) > -1;
      });
    } else {
      this.listItems = this.source;
      this.combo.toggle(false);
    }
    if (this.filterChange) {
      this.filterChange.emit(filter);
    }
  }
}
